export const FeatureFlags = Object.freeze({
  langSelect: import.meta.env.VITE_FEAT_SHOW_LANG_CHANGE === 'true',
  filterDraftDevices: import.meta.env.VITE_FEAT_FILTER_DRAFT_DEVICES === 'true',
  logRequests: import.meta.env.VITE_LOG_REQUESTS === 'true',
  logWsMessages: import.meta.env.VITE_LOG_WS_MESSAGES === 'true',
  strictOutputValidation: import.meta.env.VITE_FEAT_STRICT_OUTPUT_VALIDATION === 'true',
  showCustomerReportGeneration: import.meta.env.VITE_FEAT_SHOW_REPORT_GEN === 'true',
});
